export default "__VITE_ASSET__DI2qDy8x__"